<template>
  <div>
    <div class="news">
      <div class="my-news">
        <div class="u-flex u-row-between w100">
          <div class="title">开票记录</div>
        </div>
      </div>
      <el-table class="whitelist-table mt20" :data="dataSource">
        <el-table-column prop="order_sn" label="订单号" align="center"/>
        <el-table-column prop="email" label="开票邮箱" align="center"/>
        <el-table-column prop="price" label="金额" align="center"/>
        <el-table-column prop="createtime" label="申请时间" align="center"/>
        <el-table-column prop="status" label="状态" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status == 1" type="success">开票成功</el-tag>
            <el-tag v-if="scope.row.status == 0">等待审核</el-tag>
            <el-tag v-if="scope.row.status == 2" type="danger">审核不通过</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="op" label="操作" align="center">
          <template #default="scope">
            <el-button type="text" @click="saveInvouce(scope.row)" v-if="scope.row.status == 2">重新提交</el-button>
            <!-- <el-button type="text" size="small" @click="closeWork(scope.row)" v-if="scope.row.status == 0 || scope.row.status == 1" >关闭</el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination background @current-change="(e) => { page = e; getData() }" layout="total,prev, pager, next"
                     :total="total" :page-size="5"/>
    </div>


  </div>
</template>

<script>


export default {

  name: 'Invoice',
  data() {
    return {
      page: 1,
      total: 0,
      type: '',
      workShow: false,
      dataSource: [],
    }

  },

  created() {
    this.getData()
  },
  methods: {
    saveInvouce(row) {
      this.$prompt('请输入开票发送的邮箱', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: row.email,
        inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
        inputErrorMessage: '邮箱格式不正确'
      }).then(({value}) => {
        this.$api.invoice.submitInvoice({email: value, order_sn: row.order_sn, id: row.id}).then(res => {
          if (res.code === 1) {
            this.$message.success(res.msg)
            this.getData()
          }
        }).finally(() => {

        })
      }).catch(() => {
      });
    },
    onTab(index) {
      this.navIndex = index
    },
    getData() {
      this.$api.invoice.getList({page: this.page}).then(res => {
        this.dataSource = res.data.data
        this.total = res.data.total
      })
    },
    handleDetail(row) {
      this.$api.workOrder.getDetail({word_sn: row.word_sn}).then(res => {
        this.detailData = res.data.row
        this.detailShow = true
      })
    },
  }
}
</script>

<style scoped>
.news {
  margin-top: 20px;
  border-radius: 8px;
  //border: 1px solid #ccc;
}

.whitelist-table {
  border-radius: 0;
  overflow: hidden;
  box-shadow: none;
}

.whitelist-table ::v-deep tr th {
  background: #f5f7fa;
  color: #222;
  font-weight: 600;
  font-size: 15px;
}

.whitelist-table ::v-deep tr {
  transition: background 0.2s;
}

.whitelist-table ::v-deep tr:hover td {
  background: #f0f7ff;
}

.whitelist-table ::v-deep td,
.whitelist-table ::v-deep th {
  padding: 12px 0;
}

.title {
  font-size: 16px;
  font-weight: 600;
}

.my-news {
  padding: 20px;
}

.table ::v-deep tr th {
  background: #f5f5f5;
}

.table::before {
  height: 0;
}

.pagination {
  margin-top: 20px;
  text-align: right;
}

::v-deep .el-textarea__inner {
  height: 200px;
}

/* 聊天界面样式 */
.chat-container {
  margin-top: 20px;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  background: #f8f9fa;
}

.chat-title {
  padding: 15px 20px;
  background: #fff;
  border-bottom: 1px solid #e4e7ed;
  font-weight: 600;
  font-size: 16px;
  color: #303133;
}

.chat-messages {
  padding: 20px;
  max-height: 400px;
  overflow-y: auto;
}

.message-item {
  margin-bottom: 20px;
}

.message {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.service-message {
  flex-direction: row;
}

.user-message {
  flex-direction: row-reverse;
}

.message-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.service-message .message-avatar {
  background: #409eff;
  color: white;
}

.user-message .message-avatar {
  background: #67c23a;
  color: white;
}

.message-content {
  flex: 1;
  max-width: 70%;
}

.message-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  font-size: 12px;
  color: #909399;
}

.message-name {
  font-weight: 600;
  color: #606266;
}

.message-time {
  color: #c0c4cc;
}

.message-text {
  padding: 12px 16px;
  border-radius: 8px;
  word-wrap: break-word;
  line-height: 1.5;
}

.service-message .message-text {
  background: #fff;
  border: 1px solid #e4e7ed;
  color: #303133;
}

.user-message .message-text {
  background: #409eff;
  color: white;
}

/* 滚动条样式 */
.chat-messages::-webkit-scrollbar {
  width: 6px;
}

.chat-messages::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.chat-messages::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.chat-messages::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>
